import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { InternalStakeholdersResponse } from '@blisspointmedia/bpm-types/dist/ClientOracleOnboarding';
import { fetchInternalStakeholders } from './onboarding-api';

export const internalStakeholdersQueryKey = (company: string): string[] => [
  'internalStakeholders',
  company
];

export const useInternalStakeholders = (
  company: string
): UseQueryResult<InternalStakeholdersResponse> =>
  useQuery({
    queryKey: internalStakeholdersQueryKey(company),
    queryFn: () => fetchInternalStakeholders(company),
    enabled: Boolean(company)
  });
